import React from "react";
import { Box } from "@chakra-ui/react";

// Constants for easy customization
const BLOB_GRADIENT = "radial-gradient(circle, #2D71DC 0%, #1DADFF 100%)";
const BACKGROUND_GRADIENT = "radial-gradient(circle at center, #EDFBFF 0%, #CCF0F9 100%)";

// Blob configurations: easier to add/remove/modify blobs
const BLOBS = [
  { size: "650px", top: "-10%", left: "-10%", animation: "blob-motion-1 20s infinite" },
  { size: "700px", top: "50%", left: "50%", animation: "blob-motion-2 18s infinite" },
  { size: "600px", bottom: "-10%", right: "-10%", animation: "blob-motion-3 22s infinite" },
  { size: "680px", top: "30%", left: "20%", animation: "blob-motion-4 25s infinite" },
];

export function AgentsBlueBlobBackground() {
  return (
    <>
      <style>
        {`
          @keyframes blob-motion-1 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            33% { transform: translate(30vw, 20vh) scale(1.1); }
            66% { transform: translate(-20vw, 40vh) scale(0.9); }
          }

          @keyframes blob-motion-2 {
            0%, 100% { transform: translate(-50%, -50%) scale(1); }
            33% { transform: translate(-30%, -30%) scale(1.2); }
            66% { transform: translate(-70%, -60%) scale(0.8); }
          }

          @keyframes blob-motion-3 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            33% { transform: translate(-40vw, -30vh) scale(0.9); }
            66% { transform: translate(20vw, -50vh) scale(1.15); }
          }

          @keyframes blob-motion-4 {
            0%, 100% { transform: translate(0, 0) scale(1); }
            25% { transform: translate(40vw, -20vh) scale(1.1); }
            50% { transform: translate(-30vw, 30vh) scale(0.85); }
            75% { transform: translate(20vw, 10vh) scale(1.05); }
          }

          .animated-blob {
            position: absolute;
            border-radius: 50%;
            filter: blur(80px);
            opacity: 0.7;
            animation-timing-function: ease-in-out;
            animation-iteration-count: infinite;
          }
        `}
      </style>
      <Box position="absolute" top={0} left={0} w="100%" h="100%" overflow="hidden" background={BACKGROUND_GRADIENT}>
        {BLOBS.map((blob) => (
          <Box
            key={blob.animation}
            className="animated-blob"
            w={blob.size}
            h={blob.size}
            background={BLOB_GRADIENT}
            top={blob.top}
            left={blob.left}
            bottom={blob.bottom}
            right={blob.right}
            sx={{ animation: blob.animation }}
          />
        ))}
      </Box>
    </>
  );
}
